import { useTranslate } from '@refinedev/core';
import { GUTTER } from '@/components/mobile_preview/constants';
import { useCollectionShelfPublications } from '@/components/user_catalog/collections/useCollectionShelfPublications';
import { HomePreviewShelfTile, TILE_SIZE } from './HomePreviewShelfTile';

const PLACEHOLDER_TILES = 3;

interface HomePreviewShelfTilesProps {
  collectionId: number;
  enabled?: boolean;
}

export const HomePreviewShelfTiles = ({
  collectionId,
  enabled = true,
}: HomePreviewShelfTilesProps) => {
  const t = useTranslate();
  const { publications, isLoading } = useCollectionShelfPublications(
    collectionId,
    enabled
  );

  // Placeholders mean "still loading"; an empty collection says so instead,
  // or it reads as a shelf that simply failed to draw.
  if (!isLoading && !publications?.length)
    return (
      <div style={{ padding: `0 ${GUTTER}px`, fontSize: 12, opacity: 0.6 }}>
        {t('user_catalog.home_page.preview.empty_shelf')}
      </div>
    );

  const tiles = publications?.length
    ? publications.map((publication) => (
        <HomePreviewShelfTile key={publication.id} publication={publication} />
      ))
    : Array.from({ length: PLACEHOLDER_TILES }, (_, i) => (
        <HomePreviewShelfTile key={`placeholder-${i}`} />
      ));

  return (
    <div
      className="phone-frame-scroll"
      style={{
        display: 'flex',
        gap: 12,
        overflowX: 'auto',
        padding: `0 ${GUTTER}px`,
        // Tiles keep their width when the row overflows.
        minWidth: TILE_SIZE,
      }}
    >
      {tiles}
    </div>
  );
};
